"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentListingsWrapper$ = exports.AgentListingsWrapper$outboundSchema = exports.AgentListingsWrapper$inboundSchema = void 0;
exports.agentListingsWrapperToJSON = agentListingsWrapperToJSON;
exports.agentListingsWrapperFromJSON = agentListingsWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areaagentlistings_js_1 = require("./areaagentlistings.js");
/** @internal */
exports.AgentListingsWrapper$inboundSchema = z.object({
    attributes: areaagentlistings_js_1.AreaAgentListings$inboundSchema,
    id: z.string(),
});
/** @internal */
exports.AgentListingsWrapper$outboundSchema = z.object({
    attributes: areaagentlistings_js_1.AreaAgentListings$outboundSchema,
    id: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AgentListingsWrapper$;
(function (AgentListingsWrapper$) {
    /** @deprecated use `AgentListingsWrapper$inboundSchema` instead. */
    AgentListingsWrapper$.inboundSchema = exports.AgentListingsWrapper$inboundSchema;
    /** @deprecated use `AgentListingsWrapper$outboundSchema` instead. */
    AgentListingsWrapper$.outboundSchema = exports.AgentListingsWrapper$outboundSchema;
})(AgentListingsWrapper$ || (exports.AgentListingsWrapper$ = AgentListingsWrapper$ = {}));
function agentListingsWrapperToJSON(agentListingsWrapper) {
    return JSON.stringify(exports.AgentListingsWrapper$outboundSchema.parse(agentListingsWrapper));
}
function agentListingsWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AgentListingsWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AgentListingsWrapper' from JSON`);
}
//# sourceMappingURL=agentlistingswrapper.js.map